import {Component} from '@angular/core';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';

/**
 * Standalone inline bsDatepicker for mounting inside imperative SweetAlert2 dialogs.
 * A swal's `html` is a raw string rendered outside Angular, so the `bsDatepicker`
 * directive can't be used there directly. Instead this component is created with
 * `createComponent()` and its host element handed to swal as an HTMLElement — the
 * inline calendar avoids the popup/z-index/focus-trap issues a floating datepicker
 * would hit inside a modal. See ViewBatchComponent.showConfirmationDialog().
 */
@Component({
    standalone: true,
    imports: [BsDatepickerModule],
    template: `
        <label class="d-block mb-2">{{ label }}</label>
        <bs-datepicker-inline
            [bsValue]="value"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-default' }"
            (bsValueChange)="value = $event">
        </bs-datepicker-inline>
    `,
})
export class InlineDatePickerComponent {
    label = 'Date';
    value: Date;
    minDate?: Date;
    maxDate?: Date;
}
